import { render } from "./income.vue?vue&type=template&id=5f538fd6&scoped=true"
import script from "./income.vue?vue&type=script&lang=js"
export * from "./income.vue?vue&type=script&lang=js"

import "./income.vue?vue&type=style&index=0&id=5f538fd6&lang=scss&scoped=true"
import "./income.vue?vue&type=style&index=1&id=5f538fd6&lang=css"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f538fd6"]])

export default __exports__